module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 239.4edb5000.svg";